import { CourseData, ConnectorType } from "./coursedata";

export enum EdgeMode {
  HIDDEN, // Not rendererd
  NORMAL, // Std. Opacity
  HIGHLIGHT, // Relations of Focused Node
  SEMI_HIGHLIGHT, //Relations of Relations of Focused Node
  FOCUS, // Directly Focused
  HEATMAP,
}

interface Vector2 {
  x: number;
  y: number;
}

interface ICourseNode {
  data: CourseData;
  position: Vector2;
  stylemode: string;
  hidden: boolean;
  homeArea: number;
  relativePos: Vector2;
}

interface IConnector {
  connType: ConnectorType;
  sourceNodeRef: ICourseNode;
  destNodeRef: ICourseNode;
  styleMode: EdgeMode;
}

interface ICourseNodeCluster {
  position: Vector2;
  area: number;
  expanded: boolean;
  hasFocus: boolean;
  coreAngleArray: number[];
}

export type { Vector2, ICourseNode, ICourseNodeCluster, IConnector };
